class ErrorTracker {
  constructor() {
    this.adapter = null;
  }

  use(adapter) {
    this.adapter = adapter;
  }

  captureError(error, options = {}) {
    if (!this.adapter) {
      return;
    }

    // Some ajax calls (from the api mainly) can raises error which are not real one,
    // but direct output result from the server
    if (error.body) {
      this.adapter.captureError(new Error('Ajax error'), { context: { response: error } });
    } else {
      this.adapter.captureError(error, options);
    }

    if (options.rethrow) {
      throw error;
    }
  }

  async install(options) {
    await this.adapter.install(options);
  }
}

export default new ErrorTracker();
